import { render, staticRenderFns } from "./flowCurrent.vue?vue&type=template&id=7984b636&scoped=true"
import script from "./flowCurrent.vue?vue&type=script&lang=js"
export * from "./flowCurrent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7984b636",
  null
  
)

export default component.exports